import "material-design-icons-iconfont/dist/material-design-icons.css"; // css-loaderを使用していることを確認してください
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md", // https://fonts.google.com/icons?selected=Material+Icons
  },
});
